import Icon from '@/assets/svg/status/arquivos_com_erro.svg?raw'
import ArrowIcon from '@/assets/svg/arrow.svg?raw'
import CancelFileModal from '../../cancel-file/index.vue'
import PendingExamsMixin from '@/shared/mixins/pending-exams.mixin'
import { mapActions } from 'vuex'

export default {
  props: {
    details: {
      type: Object
    }
  },
  mixins: [PendingExamsMixin],
  components: {
    CancelFileModal
  },
  data() {
    return {
      icon: Icon,
      arrow: ArrowIcon,
      img: '/assets/img/preorder-file-error.png',
      showMessage: false,
      showCancelModal: false
    }
  },
  computed: {
    reasonsForInvalidFiles() {
      return [
        this.$t('file_error_reasons.reason_one'),
        this.$t('file_error_reasons.reason_two'),
        this.$t('file_error_reasons.reason_three')
      ]
    }
  },
  methods: {
    ...mapActions(['changeUpdateGridExams']),

    async handleCancelExam() {
      try {
        await this.cancelExamFromInvalidFileStatus(this.details.examId, 'Arquivo inválido')
        this.$root.$emit('toast', {
          message: this.$t('cancel_success_message'),
          type: 'success'
        })
        this.changeUpdateGridExams(true)
        this.showCancelModal = false
        this.$emit('close')
      } catch (e) {
        this.$root.$emit('toast', {
          message: this.$t('cancel_error_message'),
          type: 'error'
        })
        console.error(e)
      }
    },
    async onCancelConfirmed() {
      await this.handleCancelExam()
    }
  }
}
